// extracted by mini-css-extract-plugin
export default {"modal":"ConnectPlusModal_modal__ZdjWL","ant-modal":"ConnectPlusModal_ant-modal__cJeJv","ant-modal-content":"ConnectPlusModal_ant-modal-content__G0hsS"};